import { FilterForm } from "./filter-form";

export function OtherControl() {
  return <FilterForm view="onlyOther" />;
}
